module.exports = __webpack_public_path__ + "static/media/bushu-03.3addff4e.png";